import React from 'react'

import { Spinner } from '@octane/spark'

import { SizedContainer, ModalSpinnerDivStyle } from './LoadingSpinner.styled'

type SizedLoadingSpinnerProps = {
    height?: string
    width?: string
    text?: string
}

function SizedLoadingSpinner({
    height = '600px',
    width = '800px',
    text = '',
}: Readonly<SizedLoadingSpinnerProps>) {
    return (
        <SizedContainer width={width} height={height}>
            <ModalSpinnerDivStyle>
                <Spinner size={100} shadow speed={0.7} background />
            </ModalSpinnerDivStyle>
            <div
                style={{
                    position: 'relative',
                    bottom: -210,
                }}
            >
                {text}
            </div>
        </SizedContainer>
    )
}

export default SizedLoadingSpinner
